import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useMemo } from 'react';

import { type KeyboardOs } from '@/types/keyboard';

export const useDeviceMatch = () => {
  const theme = useTheme();

  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isDownXl = useMediaQuery(theme.breakpoints.down('xl'));

  const isMobile = isDownSm;
  const isTablet = isDownMd;
  const isLgDown = isDownLg;
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const platform = navigator.userAgent || navigator.platform;

  const isMac = /Mac|iPod|iPhone|iPad/.test(platform);

  const os = useMemo<KeyboardOs>(() => (isMac ? 'mac' : 'windows'), [isMac]);

  return { isMobile, isTablet, isLgUp, isLgDown, isDownSm, isDownMd, isDownLg, isDownXl, os };
};
